<template>
  <ModalButton
    v-model="isModalVisible"
    icon="trash"
    modal-class="modal-center"
    :no-close-button="isDeleting"
  >
    <template #button>Delete Event</template>
    <template #modal-title>Delete Event</template>
    <template #modal-content>
      <div class="error-message" v-if="error">
        <p>The event couldn't be deleted because of an unknown error; please try again later.</p>
      </div>
      <template v-else>
        <p>
          Are you sure you want to delete the event
          <strong>{{ event.name }}?</strong>
        </p>
        <p>
          <strong>This is permanent and can't be undone!</strong>
        </p>
        <div class="flex-center gap-16 wrap mt-8">
          <BaseButton
            class="button-primary button-danger"
            :disabled="isDeleting"
            @click="deleteEvent"
          >
            Yes, delete this event.
          </BaseButton>
          <BaseButton class="button-secondary" @click="isModalVisible = false">
            No, wait!
          </BaseButton>
        </div>
      </template>
    </template>
  </ModalButton>
</template>

<script>
import JobEvent from '@/models/JobEvent';

export default {
  name: 'DeleteEventButton',
  model: {
    prop: 'event',
    event: 'delete',
  },
  props: {
    event: {
      type: JobEvent,
      required: true,
    },
    /** @type {import('vue/types/options').PropOptions<import('vue-router').RawLocation | null>} */
    redirect: {
      default: null,
    },
  },
  data() {
    return {
      /** @type {boolean} */
      error: false,
      /** @type {boolean} */
      isDeleting: false,
      /** @type {boolean} */
      isModalVisible: false,
    };
  },
  methods: {
    /**
     * @returns {Promise<void>}
     */
    async deleteEvent() {
      const { event, redirect } = this;
      try {
        this.error = false;
        if (!event || event.isDeleted || this.isDeleting) {
          return;
        }
        this.isDeleting = true;
        await this.$store.dispatch('events/deleteEvent', event);
        this.$store.commit('events/setSearchQueue', null);
      } catch (e) {
        this.error = true;
        console.error(e);
      }
      this.isModalVisible = false;
      if (event && !this.error) {
        this.$emit('delete', event);
        if (redirect) {
          this.$router.replace(redirect);
        }
      }
    },
  },
};
</script>
